import React, { memo, useEffect, useState } from 'react'

import ReactFileBase64 from '../../components/ReactFileBase64'
import { FormGrid, FormRow, FormLabel, TextInput, FieldError, GhostButton, tokens } from '../../components/ui'

/* Só os campos: a casca do modal (cabeçalho, rodapé e o próprio <form>)
   vem do componente FormModal, igual em todas as telas. */
const Form = ({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => {
  const [preview, setPreview] = useState(values.image || '')

  useEffect(() => {
    setPreview(values.image || '')
  }, [values.image])

  const handleUpload = files => {
    if (!files || files.length === 0) return
    // `setFieldValue` no lugar de mutar `values` direto: o código antigo fazia
    // `values.image = ...` dentro de um efeito, o que não avisa o Formik.
    setFieldValue('image', files[0].base64)
  }

  return (
    <FormGrid>
      <FormRow $full>
        <FormLabel>Nome</FormLabel>
        <TextInput autoComplete='nope' name='name' value={values.name || ''}
          onChange={handleChange} onBlur={handleBlur} $error={!!errors.name} />
        <FieldError>{touched.name && errors.name}</FieldError>
      </FormRow>

      <FormRow $full>
        <FormLabel>Descrição</FormLabel>
        <TextInput autoComplete='nope' name='description' value={values.description || ''}
          onChange={handleChange} onBlur={handleBlur} $error={!!errors.description} />
        <FieldError>{touched.description && errors.description}</FieldError>
      </FormRow>

      <FormRow $full>
        <FormLabel>Imagem</FormLabel>
        <ReactFileBase64 multiple={false} onDone={handleUpload} />
        {preview
          ? (
            <div style={{ marginTop: 10 }}>
              <img
                src={preview}
                alt='Pré-visualização do banner'
                style={{ maxWidth: '100%', maxHeight: 160, borderRadius: 8, border: `1px solid ${tokens.border}` }}
              />
              <div style={{ marginTop: 8 }}>
                <GhostButton type='button' onClick={() => setFieldValue('image', '')}>Remover imagem</GhostButton>
              </div>
            </div>
          )
          : <FieldError>{touched.image && errors.image}</FieldError>}
      </FormRow>
    </FormGrid>
  )
}

export default memo(Form)
